import React from "react";
import Dashboard from "./Dashboard";
import History from "./History";

function Overview() {
    return (
        <>
        <Dashboard />

        <History />
        </>
    )
}

export default Overview;